var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-navigation-drawer',{staticClass:"elevation-0",attrs:{"app":"","permanent":"","width":"240"}},[_c('SidebarNav')],1),_c('v-main',{staticClass:"main-slot"},[_c('v-container',{staticClass:"dashboard-layout pa-0",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }